import BaseElementContainer from "./BaseElementContainer";
import PropTypes from "prop-types";
import React, {createRef} from "react";
import VerticalLayout from "../layouts/VerticalLayout";
import {Tabs} from "@mui/material";
import TabPanel from "./TabPanel";
import BaseTab from "../../../appl/view/components/tabbar/BaseTab";

// TODO: peto, temp, kann nachher umbenannt werden --> TabBarHorizontal2 --> TabBarHorizontal
class TabBarHorizontal2 extends BaseElementContainer {

  constructor(props) {
    super(props);
    this.state = {
      tabs: [], value: 0
    };
  }

  handleChange = (event, newValue) => {
    this.state.value = newValue;
    this.setState(this.state);
  };

  addTab = (tabTitle, tabContent) => {
    this.setState((prevState) => {
      const newTabId = prevState.tabs.length;
      const newTab = {id: newTabId, label: tabTitle, content: tabContent};
      return {
        tabs: [...prevState.tabs, newTab], value: newTabId
      };
    });
  };

  removeTab = (event, id) => {
    // this.setState((prevState) => {
    //   const updatedTabs = prevState.tabs.filter((tab) => tab.id !== id);
    //   const newValue = prevState.value >= updatedTabs.length ? updatedTabs.length - 1 : prevState.value;
    //   return { tabs: updatedTabs, value: newValue };
    // });

    this.private_removeTabFromArray(id);
    this.setState(this.state);
  };

  private_evaluateNextTabId(id) {
    //            5
    //            v
    // [0,1,2,3,4,5] l=6
    //this.state.tabs

    let lastIndex = this.state.tabs.length - 1;
    if (lastIndex < 0) {
      lastIndex = 0;
    }
    if (id + 1 <= lastIndex) {
      id++;
    }
    return id;
  }

  private_removeTabFromArray(id) {
    //let indexFound = 0;

    this.state.tabs.map((tab, index) => {


      if (index < this.state.tabs.length - 1) {
        tab.content = this.state.tabs[index + 1].content;
      }
      return tab;


    });

    this.state.value = 0;

    // let newTabs = [];
    // for (let i = 0; i < this.state.tabs.length; i++) {
    //   let tab = this.state.tabs[i];
    //
    //   if (tab.id !== id) {
    //     newTabs.push({id: tab.id, label: tab.label, content: tab.content});
    //   } else {
    //     indexFound = i;
    //   }
    // }
    // this.state.tabs = newTabs;
    //
    // this.state.tabs.map((tab, index) => {
    //   tab.id = index;
    //   return tab;
    // });



    // this.state.tabs = this.state.tabs.filter((tab, index) => {
    //   if (tab.id === id) {
    //     indexFound = index;
    //     return false;
    //   }
    //   return true;
    // });
    // if (indexFound >= this.state.tabs.length) {
    //   indexFound = this.state.tabs.length - 1;
    // }
    // if (indexFound < 0) {
    //   indexFound = 0;
    // }
    // this.state.tabs.map((tab, index) => {
    //   tab.id = index;
    //   return tab;
    // });
    // this.state.value = indexFound;


    // let nextId = this.private_evaluateNextTabId(id);
    //
    // this.handleChange(null, nextId);
    //
    // setTimeout(() => {
    //
    //
    //   // this.state.tabs.map((tab, index) => {
    //   //   tab.id = index;
    //   //   return tab;
    //   // });
    //   // this.state.contents.map((content, index) => {
    //   //   content.id = index;
    //   //   return content;
    //   // });
    //   this.setState(this.state);
    // }, 3000);

  }

  render() {
    const {tabs, value, contents} = this.state;
    return <VerticalLayout className={'CNINFO-TabBarHorizontal2 h-full p-2 ' + this.props.className}>
      <Tabs value={value} onChange={this.handleChange}>
        {tabs.map((tab) => (<BaseTab key={createRef()} index={tab.id} selected={value === tab.id} label={tab.label} onClick={this.handleChange} onRemoveClick={this.removeTab}/>))}
      </Tabs>
      {tabs.map((tab) => (<TabPanel key={createRef()} index={tab.id} selected={value === tab.id} value={value}>{tab.content}</TabPanel>))}
      {/*{contents.map((content) => (<TabPanel key={createRef()} index={content.id} selected={value === content.id} value={value} content={content.content}/>))}*/}
    </VerticalLayout>;
  }
}

TabBarHorizontal2.propTypes = {
  className: PropTypes.string
};
export default TabBarHorizontal2;
